// extracted by mini-css-extract-plugin
export var link = "_s6-0";